import * as angular from 'angular';

import { ComponentDefinition } from '../../../models';

class TableCellController implements angular.IComponentController {
    decimals: number;
    isDirty: boolean;
    isLoading: boolean;
    isNaN: boolean;
    loadingMessage: string;
    useFormattedValue: boolean;
    value: any;

    static $inject = [];

    $onInit() {
        this.isNaN = isNaN(this.value?.value);
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        this.isNaN = isNaN(this.value?.value);
    }
}

export const wtTableCell: ComponentDefinition = {
    componentId: 'wtTableCell',
    controller: TableCellController,
    template: require('./tableCell.component.html'),
    controllerAs: 'vm',
    bindings: {
        clickCell: '&?',
        decimals: '<?',
        hasManualInputRole: '<?',
        isDirty: '<?',
        showLogbook: '<?',
        useFormattedValue: '<?',
        value: '<'
    }
};